import DefaultSlot from './DefaultSlot';
import { jsx as _jsx } from "react/jsx-runtime";
export default function IndexBodySlot(props) {
  return /*#__PURE__*/_jsx(DefaultSlot, Object.assign({}, props));
}